/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

export const viewHistoryTableHead = [
  {
    headerName: 'Time Stamp',
    field: 'timestamp',
    editable: false,
    sortable: true,
    sort: 'desc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    comparator: (valueA, valueB) => {
      const dateA = new Date(valueA);
      const dateB = new Date(valueB);
      return dateA.getTime() - dateB.getTime();
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'User',
    field: 'user',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'userNameRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 2,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Activity',
    field: 'activity',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Column Name',
    field: 'columnName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'columnNameRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 3,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Before Value',
    field: 'beforeValue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'beforeValueRender',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'After Value',
    field: 'afterValue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'afterValueRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
